module.exports = __webpack_public_path__ + "static/media/campus-upsell-popup.c3400d4f.mp3";